import { useNavigate } from "react-router-dom";

import LokasiIntelligenceLogo from "@/assets/svg/logo.svg?react";
import WarningBubble from "@/assets/svg/warningBubble.svg?react";
import { Button } from "@/components/ui/button";

type ExpiredLinkProps = {
  heaaderText?: string;
  topDescriptionText?: string;
  bottomDescriptionText?: string;
  ctaButtonText?: string;
};

const ExpiredLink = ({
  heaaderText = "Link Expired",
  topDescriptionText = "Your password reset link has expired.",
  bottomDescriptionText = "Request a new one to continue.",
  ctaButtonText = "Back to Sign In"
}: ExpiredLinkProps): JSX.Element => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen min-w-screen bg-white p-10">
      <div className="flex justify-center" data-testid="lokasi-logo">
        <LokasiIntelligenceLogo title="Lokasi Intelligence Logo" />
      </div>

      <div
        className="flex flex-col flex-1 items-center justify-center mt-[-80px]"
        data-testid="content-wrapper"
      >
        <WarningBubble className="w-32 h-32 fill-dim-gray mb-6" />

        <h1 className="text-[32px] leading-10 font-semibold text-txtHeading mb-2">
          {heaaderText}
        </h1>

        <p className="text-sm leading-[22px] text-txtBody">
          {topDescriptionText}
        </p>
        <p className="text-sm leading-[22px] text-txtBody">
          {bottomDescriptionText}
        </p>

        <Button
          onClick={() => {
            navigate("/login");
          }}
          className="w-full mt-20 rounded-xl min-w-[424px] h-12 font-semibold text-base"
        >
          {ctaButtonText}
        </Button>
      </div>
    </div>
  );
};

export default ExpiredLink;
